import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import api from '../utils/axios'; // the axios instance we made

const ProtectUser = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      if (userInfo) {
        setIsAuthenticated(true);
        setLoading(false);
      } else {
        try {
          // Ping backend to verify token/cookie
          const { data } = await api.get('/auth/verify');
          dispatch({ type: 'LOGIN_SUCCESS', payload: data.user }); // restore Redux
          setIsAuthenticated(true);
        } catch (err) {
          setIsAuthenticated(false);
        } finally {
          setLoading(false);
        }
      }
    };
    checkAuth();
  }, [userInfo, dispatch]);

  if (loading) return <p>Loading...</p>;

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectUser;
